<input class="form-control custom-control nostyle w-100"
       [ngClass]="{'fail-input': _errorMsg}"
       id="phoneInput" #phoneInput
       (blur)="inputChange()" type="tel">
